import React from "react";

import { Button } from "components";

import tinycolor from "tinycolor2";
import { sizes, colors } from "assets/constants";
import { useChangeStepFlags } from "../../hooks/useChangeStepFlags";
import toast from "components/toast";

type PropsT = {
  item: FactorItemT;
  onRemove: () => void;
  goToChangeStep: () => void;
  onCloseChangeStep: () => void;
  disableAction?: boolean;
};

const Actions: React.FC<PropsT> = (props) => {
  const {
    multiItemsChangeStepMode,
    singleItemChangeStepMode,
    singleItemChangeStepModeForAll,
    countEditingMode,
  } = useChangeStepFlags();

  const _goToChangeStep = () => {
    if (countEditingMode) {
      toast.warning({ message: "ابتدا تغییرات اطلاعات را ثبت نمایید" });
      return;
    }
    props.goToChangeStep && props.goToChangeStep();
  };

  if (multiItemsChangeStepMode) {
    return null;
  }

  if (singleItemChangeStepMode(props.item.id)) {
    return (
      <Button
        disabled={props.disableAction}
        style={{ opacity: props.disableAction ? 0.5 : 1 }}
        onPress={props.onCloseChangeStep}
        square={35}
        icon={{ name: "x", size: 25, color: colors.danger }}
        bgColor={colors.transparent}
        bordered={{
          width: 1,
          color: tinycolor(colors.danger).lighten(25).toString(),
        }}
      />
    );
  }

  if (
    singleItemChangeStepModeForAll &&
    !singleItemChangeStepMode(props.item.id)
  ) {
    return (
      <Button
        disabled={props.disableAction}
        style={{ opacity: props.disableAction ? 0.5 : 1 }}
        square={35}
        onPress={_goToChangeStep}
        icon={{ name: "repeat", size: 20, color: colors.theme }}
        bgColor={colors.transparent}
        bordered={{
          width: 1,
          color: tinycolor(colors.theme).lighten(25).toString(),
        }}
      />
    );
  }

  return (
    <>
      <Button
        disabled={props.disableAction}
        style={{ opacity: props.disableAction ? 0.5 : 1 }}
        square={35}
        onPress={_goToChangeStep}
        icon={{ name: "repeat", size: 20, color: colors.theme }}
        bgColor={colors.transparent}
        bordered={{
          width: 1,
          color: tinycolor(colors.theme).lighten(25).toString(),
        }}
      />

      <Button
        disabled={props.disableAction}
        style={{
          marginLeft: sizes.space,
          opacity: props.disableAction ? 0.5 : 1,
        }}
        onPress={props.onRemove}
        square={35}
        bgColor={colors.transparent}
        icon={{ name: "trash", size: 20, color: colors.danger }}
        bordered={{
          width: 1,
          color: tinycolor(colors.danger).lighten(25).toString(),
        }}
      />
    </>
  );
};

export default Actions;
